import { IconWrapper } from '../runtime';
export default IconWrapper('dribble', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M44 24C44 29.5386 41.7486 34.5513 38.1112 38.173C34.4943 41.7742 29.5071 44 24 44C12.9543 44 4 35.0457 4 24C4 18.6615 6.09159 13.8116 9.5 10.225C13.1439 6.39055 18.2928 4 24 4C29.5071 4 34.4943 6.22583 38.1112 9.82695C41.7486 13.4487 44 18.4614 44 24Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M44.0003 24C41.0819 24 33.0315 22.8993 25.8268 26.0632C18.0003 29.5002 12.3327 34.8315 9.86328 38.1472",
      "stroke": props.colors[2],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M16.5 5.45386C19.6304 8.34275 26.4603 15.6986 29 23.0001C31.5397 30.3016 32.4809 39.2792 33.0606 41.8348",
      "stroke": props.colors[2],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M4.1543 21.5C7.93207 21.7277 17.9329 21.9332 24.3329 19.1999C30.7329 16.4666 36.2402 11.4396 38.1291 9.84521",
      "stroke": props.colors[2],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M5.5 31.6132C7.26166 35.8894 10.4628 39.4209 14.5 41.6041",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M4 24C4 18.6616 6.09159 13.8116 9.5 10.225",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M24 4C18.2928 4 13.1439 6.39055 9.5 10.225",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M32 5.66418C34.2933 6.66618 36.3624 8.08582 38.1112 9.82696C41.7486 13.4487 44 18.4614 44 24C44 26.4627 43.5549 28.8213 42.7408 31",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M24 44C29.5071 44 34.4943 41.7742 38.1112 38.1731",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })]);
});